import { render, staticRenderFns } from "./PostalCodeIndex.vue?vue&type=template&id=788bcf7e&scoped=true&"
import script from "./PostalCodeIndex.vue?vue&type=script&lang=js&"
export * from "./PostalCodeIndex.vue?vue&type=script&lang=js&"
import style0 from "./PostalCodeIndex.vue?vue&type=style&index=0&id=788bcf7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788bcf7e",
  null
  
)

export default component.exports